module.exports = __webpack_public_path__ + "img/result.6b2d3a78.png";